import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    { path: '/', name: 'Home', component: () => import('./components/HomePage.vue') },
    { path: '/ArtistsSeenPage', name: 'ArtistsSeen', component: () => import('./components/ArtistsSeenPage.vue') },
    { path: '/PlacesPage', name: 'Places', component: () => import('./components/PlacesPage.vue') },
    { path: '/VenuesPage', name: 'Venues', component: () => import('./components/VenuesPage.vue') },
    { path: '/SpotifyPage', name: 'Spotify', component: () => import('./components/SpotifyPage.vue') },
    { path: '/artist/:mbid', name: 'ArtistDetail', component: () => import('./components/ArtistDetail.vue') },
    { path: '/artist/:mbid/concerts', name: 'ArtistConcerts', component: () => import('./components/ArtistConcerts.vue') },
    { path: '/concerts/:year', name: 'concerts-by-year', component: () => import('@/components/ConcertsByYear.vue')}
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;
